import Facilities       from "../../../domain/facility/Facilities";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_FACILITIES = "SET_FACILITIES"
}

export interface FacilitySetAction extends ResKaReduxAction {
  facilities: Facilities
}

export type FacilityAction = FacilitySetAction;

export const facilitiesSetAction = (facilities: Facilities): FacilitySetAction => ({
  type: ACTION_TYPE.SET_FACILITIES,
  facilities: facilities,
});